import React from 'react'

export function PasswordWarning(props) {

    if(props.passWarning === true){
        return (
            <div className="password-warning">
                Passwords do not match!
            </div>
        )
    } else {
        return null
    }
}